import { FC, useEffect } from "react";
import "../../styles/home-page.css";
import {
  CheckAuthentication,
  UpdateUserLastActionDate,
} from "../../helper/ui/methods";
import { useAppStateContext } from "../../middleware/context/state-context-provider";
import { useNavigate } from "react-router-dom";
import MainNavigationPanel from "../ui/user/main-navigation-panel";
import MainFooterPanel from "../ui/user/main-footer-panel";

export const Home: FC = () => {
  const [state, dispatch] = useAppStateContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      CheckAuthentication(dispatch);
    }
  }, []);

  useEffect(() => {
    if (state.user) {
      UpdateUserLastActionDate(state.user, dispatch);
    }
  }, [state.user]);

  return (
    <>
      <div
        id="pageWrapper"
        onClick={
          state.user
            ? () => UpdateUserLastActionDate(state.user!, dispatch)
            : undefined
        }
      >
        <MainNavigationPanel user={state.user} />
        <div id="contentWrapper">
          <div id="content" className="pageSurface">
            <div id="informationCanvas">
              <span className="pageEyebrow">Digital Charcoal</span>
              <h1>Turning Complexity into Simplicity</h1>
              <p>
                We offer software solutions designed to enhance collaboration in
                information management, streamline project workflows, and
                optimize BIM coordination. Our cloud-hosted and on-premises
                tools ensure seamless construction data management, fostering
                better communication and increasing efficiency.
              </p>

              <div className="informationItem">
                <div className="informationItemContentWrapper">
                  <h2>Coordination</h2>
                  <p>
                    <b>Charvue</b>, part of our ForgeLine Navisworks plugin, is
                    a powerful tool that allows you to create custom reports
                    from your Navisworks models. <br /> With just a click, you can
                    seamlessly upload these reports to our cloud-based
                    ecosystem, enabling all stakeholders in your BIM
                    coordination process to view and collaborate in real-time.
                  </p>
                </div>
                <div className="informationItemMediaWrapper">
                  <iframe
                    src="https://www.youtube-nocookie.com/embed/EdfXjgzn0HM?si=A_iZ3B1-3W7fELT-"
                    title="YouTube video player"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              <div className="informationItem">
                <div className="informationItemMediaWrapper">
                  <iframe
                    src="https://www.youtube-nocookie.com/embed/AyPnFDENuyg?si=qd98srQ-X1aF3WU1"
                    title="YouTube video player"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="informationItemContentWrapper">
                  <h2>Model Based Estimation</h2>
                  <p>
                    <b>QTO TOOL</b>, is a Rhino plugin designed for advanced,
                    model-based concrete estimation. Seamlessly generate
                    tailored values for your concrete projects and export them
                    into a well-organized spreadsheet or a data-rich IFC model.
                  </p>
                </div>
              </div>

              <h3>Pricing</h3>
              <p>
                Every seat is $50 a month, or $500 a year, and opens on a
                30-day trial of the whole product.
              </p>
              <div className="pageActionWrapper">
                <span
                  className="pageAction pageActionPrimary"
                  onClick={() => {
                    navigate("/pricing");
                  }}
                >
                  See pricing
                </span>
              </div>
            </div>
          </div>
        </div>
        <MainFooterPanel />
      </div>
    </>
  );
};
